import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhilippines = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_2043)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0V12L3.51468 20.4853C5.68626 22.6568 8.68625 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37262 12 0 12 0Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 0C8.68625 0 5.68626 1.34316 3.51468 3.51469C6.4589 6.45891 7.50407 7.50412 12 12H24C24 5.37262 18.6274 0 12 0Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.21677 12L6.75127 11.3107L7.53169 9.89135L5.94028 10.1958L5.73863 8.58813L4.63013 9.77051L3.52167 8.58813L3.31997 10.1958L1.72861 9.89131L2.50903 11.3107L1.04349 12L2.50903 12.6894L1.72861 14.1087L3.32011 13.8043L3.52163 15.4119L4.63013 14.2295L5.73863 15.4119L5.94028 13.8043L7.5316 14.1087L6.75122 12.6894L8.21677 12Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.2003 4.69568L3.68799 5.37738L4.48697 5.1243L3.98925 5.79874L4.47694 6.48044L3.68166 6.21555L3.18399 6.88994L3.19022 6.05182L2.39499 5.78688L3.19411 5.5338L3.2003 4.69568Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.2003 17.1101L3.68799 17.7918L4.48697 17.5387L3.98925 18.2132L4.47694 18.8949L3.68166 18.63L3.18399 19.3044L3.19022 18.4662L2.39499 18.2013L3.19411 17.9482L3.2003 17.1101Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.1562 10.9029L9.66857 11.5846L8.86954 11.3314L9.36726 12.0059L8.87957 12.6877L9.67485 12.4227L10.1726 13.0971L10.1663 12.259L10.9615 11.9941L10.1624 11.741L10.1562 10.9029Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_2043",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgPhilippines;
